<!-- *ngIf="RBACORG" -->
<div [attr.data-subcategory]="'Case Inbox'">
  <div class="case-inbox-container">
    <!-- <div class="case-inbox-header">
      <h6>Inbox</h6>
    </div>
    <hr/> -->
    
    <!-- Navigation Section -->
    <div class="case-inbox-navigation">
      <!-- Navigation Tabs -->
      <div class="nav-tabs">
        <button 
          *ngFor="let tab of tabs" 
          class="nav-tab" 
          [class.active]="activeTab === tab.id"
          (click)="switchTab(tab.id)">
          <span class="tab-label">{{ tab.label }}</span>
          <span class="tab-count">{{ tab.count }}</span>
        </button>
      </div>
      
      <!-- Search and New Message Section -->
      <div class="search-section">
        <button class="refresh-btn" (click)="loadMessages()" matTooltip="Refresh">
          <i class="fa fa-refresh"></i>Refresh
        </button>
        <!-- Search Bar -->
        <div class="search-bar">
          <i class="fa fa-search search-icon"></i>
          <input 
            type="text" 
            class="search-input" 
            placeholder="Search" 
            [(ngModel)]="searchQuery"
            (ngModelChange)="onSearchChange($event)">
          <button 
            *ngIf="searchQuery" 
            class="clear-search-btn" 
            (click)="clearSearch()">
            ×
          </button>
        </div>
        
        <!-- New Message Button -->
        <button *ngIf="!isApplicant && !ActivateReadOnlyMode && getCurrentUserRole() !== 'Educator'"
          class="btn btn-primary btn-md float-right" 
          (click)="onNewMessage()"
          [disabled]="isLoadingCaseUsers">
          <span class="plus-icon">+</span>
          <span *ngIf="!isLoadingCaseUsers">New Message</span>
          <span *ngIf="isLoadingCaseUsers">Loading...</span>
        </button>
      </div>
    </div>
    <hr/>
    <!-- Two-Pane Layout: Inbox Listing and Message Details -->
    <div class="inbox-layout">
      <!-- Left Pane: Dynamic Listing Based on Active Tab -->
      <div class="inbox-listing-pane" (scroll)="onScroll($event)">
        <!-- Inbox Listing -->
        <div *ngIf="activeTab === 'inbox'">
          <!-- Initial Loading State -->
          <div *ngIf="isLoadingInbox" class="loading-state">
            <i class="fa fa-spinner fa-spin"></i>
            <p>Loading inbox messages...</p>
          </div>
          
          <!-- Empty State -->
          <div *ngIf="!isLoadingInbox && currentInboxItems.length === 0" class="empty-state">
            <i class="fa fa-inbox empty-icon"></i>
            <h4>No Messages</h4>
            <p>Your inbox is empty.</p>
          </div>
          
          <!-- Inbox Content -->
          <app-inbox-listing 
            *ngIf="!isLoadingInbox && currentInboxItems.length > 0"
            [inboxItems]="currentInboxItems"
            [selectedItemId]="selectedInboxItemId"
             (itemClicked)="onInboxItemClicked($event)">
          </app-inbox-listing>
          
          <!-- Loading More Indicator -->
          <div *ngIf="isLoadingMoreInbox" class="loading-more-state">
            <i class="fa fa-spinner fa-spin"></i>
            <p>Loading more messages...</p>
          </div>
          
          <!-- No More Messages Indicator -->
          <div *ngIf="!inboxPagination.hasMore && currentInboxItems.length > 0 && !isLoadingMoreInbox && inboxPagination.hasScrolled" class="no-more-messages">
            <p>No more messages to load</p>
          </div>
        </div>

        <!-- Sent Listing -->
        <div *ngIf="activeTab === 'sent'">
          <!-- Initial Loading State -->
          <div *ngIf="isLoadingSent" class="loading-state">
            <i class="fa fa-spinner fa-spin"></i>
            <p>Loading sent messages...</p>
          </div>
          
          <!-- Empty State -->
          <div *ngIf="!isLoadingSent && currentSentItems.length === 0" class="empty-state">
            <i class="fa fa-paper-plane empty-icon"></i>
            <h4>No Sent Messages</h4>
            <p>You haven't sent any messages yet.</p>
          </div>
          
          <!-- Sent Content -->
          <app-sent-listing
            *ngIf="!isLoadingSent && currentSentItems.length > 0"
            [sentItems]="currentSentItems"
            [selectedItemId]="selectedInboxItemId"
            (itemClicked)="onSentItemClicked($event)">
          </app-sent-listing>
          
          <!-- Loading More Indicator -->
          <div *ngIf="isLoadingMoreSent" class="loading-more-state">
            <i class="fa fa-spinner fa-spin"></i>
            <p>Loading more messages...</p>
          </div>
          
          <!-- No More Messages Indicator -->
          <div *ngIf="!sentPagination.hasMore && currentSentItems.length > 0 && !isLoadingMoreSent && sentPagination.hasScrolled" class="no-more-messages">
            <p>No more messages to load</p>
          </div>
        </div>

        <!-- Draft Listing -->
        <div *ngIf="activeTab === 'draft'">
          <!-- Initial Loading State -->
          <div *ngIf="isLoadingDraft" class="loading-state">
            <i class="fa fa-spinner fa-spin"></i>
            <p>Loading draft messages...</p>
          </div>
          
          <!-- Empty State -->
          <div *ngIf="!isLoadingDraft && currentDraftItems.length === 0" class="empty-state">
            <i class="fa fa-edit empty-icon"></i>
            <h4>No Draft Messages</h4>
            <p>You don't have any draft messages.</p>
          </div>
          
          <!-- Draft Content -->
          <app-draft-listing
            *ngIf="!isLoadingDraft && currentDraftItems.length > 0"
            [draftItems]="currentDraftItems"
            [selectedItemId]="selectedInboxItemId"
            (itemClicked)="onDraftItemClicked($event)"
            (itemEdit)="onDraftEdit($event)"
            (itemDelete)="onDraftDelete($event)">
          </app-draft-listing>
          
          <!-- Loading More Indicator -->
          <div *ngIf="isLoadingMoreDraft" class="loading-more-state">
            <i class="fa fa-spinner fa-spin"></i>
            <p>Loading more messages...</p>
          </div>
          
          <!-- No More Messages Indicator -->
          <div *ngIf="!draftPagination.hasMore && currentDraftItems.length > 0 && !isLoadingMoreDraft && draftPagination.hasScrolled" class="no-more-messages">
            <p>No more messages to load</p>
          </div>
        </div>

        <!-- Archive Listing -->
        <div *ngIf="activeTab === 'archive'">
          <!-- Initial Loading State -->
          <div *ngIf="isLoadingArchive" class="loading-state">
            <i class="fa fa-spinner fa-spin"></i>
            <p>Loading archived messages...</p>
          </div>
          
          <!-- Empty State -->
          <div *ngIf="!isLoadingArchive && currentArchivedItems.length === 0" class="empty-state">
            <i class="fa fa-archive empty-icon"></i>
            <h4>No Archived Messages</h4>
            <p>You don't have any archived messages.</p>
          </div>
          
          <!-- Archive Content -->
          <app-archive-listing
            *ngIf="!isLoadingArchive && currentArchivedItems.length > 0"
            [archiveItems]="currentArchivedItems"
            [selectedItemId]="selectedInboxItemId"
            (itemClicked)="onArchivedItemClicked($event)">
          </app-archive-listing>
          
          <!-- Loading More Indicator -->
          <div *ngIf="isLoadingMoreArchive" class="loading-more-state">
            <i class="fa fa-spinner fa-spin"></i>
            <p>Loading more messages...</p>
          </div>
          
          <!-- No More Messages Indicator -->
          <div *ngIf="!archivePagination.hasMore && currentArchivedItems.length > 0 && !isLoadingMoreArchive && archivePagination.hasScrolled" class="no-more-messages">
            <p>No more messages to load</p>
          </div>
        </div>
      </div>
      
      <!-- Right Pane: Message Details -->
      <div class="message-details-pane">
        <app-message-details
          [message]="selectedMessage"
          [isVisible]="!!selectedMessage"
          [ActivateReadOnlyMode]="ActivateReadOnlyMode"
          (reply)="onMessageReply($event)"
          (forward)="onMessageForward($event)"
          (edit)="onMessageEdit($event)"
          (archive)="onMessageArchive($event)"
          (unArchive)="onMessageUnarchive($event)">
        </app-message-details>
      </div>
    </div>
  </div>

  <!-- New Message Modal -->
  <app-new-message
    [isVisible]="showNewMessageModal"
    [caseUsers]="caseUsers"
    [applicationid]="currentApplicationId"
    [isLoadingUsers]="isLoadingCaseUsers"
    [prepopulatedData]="prepopulatedMessageData"
    [mode]="messageModalMode"
    [notAllowed]="isApplicant"
    [ActivateReadOnlyMode]="ActivateReadOnlyMode"
    [priorityOptions]="priorityOptions"
    (close)="onNewMessageClose()"
    (send)="onNewMessageSend($event)"
    (saveAsDraft)="onNewMessageSaveAsDraft($event)">
  </app-new-message>
</div>